// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"ea9e3217","675":"e3447d86","680":"2047ac60","906":"af0df4d2"}[chunkId] + ".chunk.js";
};